import React, { useRef } from 'react';

// Components
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import type { GenericEntityType } from 'actions/types/website/EntityActionTypes';
import AddAVirtualEventButton from 'components/manage/common/AddAVirtualEventButton';
import EditPageSortableList from '../EditPageSortableList';

// Types
import type { SharedEntityProps } from '../types';

// Styles
import './EditPageAddEntity.less';

type EditPageAddEntityProps = {
  children?: React.ReactChildren;
  entities: { [key: number]: GenericEntityType };
  entitiesListTitle?: string;
  entityApiName?: string;
  entityDetailProps: SharedEntityProps;
  entityName?: string;
  isVirtualEventTourDisabled?: boolean;
  onAdd?: (ref: React.MutableRefObject<null>) => void;
  onAddButton?: React.ReactNode;
  onAddText?: string;
  orderedIds: number[];
  pageType?: string;
};

const EditPageAddEntity = ({
  children,
  entities,
  entitiesListTitle,
  entityApiName,
  entityDetailProps,
  entityName,
  isVirtualEventTourDisabled,
  onAdd,
  onAddButton,
  onAddText,
  orderedIds,
  pageType,
}: EditPageAddEntityProps): JSX.Element => {
  const triggerRef = useRef(null);
  const entityType = pageType && pageType.toLowerCase();
  const showVirtualEventButton = isVirtualEventTourDisabled;

  const handleAddClick = () => (onAdd ? onAdd(triggerRef) : undefined);

  return (
    <section className={`edit-page__add-entity-section add-entity-section--${entityType}`}>
      <div className="entities-list-section">
        <h4 className="entities-list-title">{entitiesListTitle || `Your ${entityName}s`}</h4>
        <div className="entities-list-wrap">
          <>
            {children || (
              <EditPageSortableList
                entities={entities}
                entityApiName={entityApiName}
                entityDetailProps={entityDetailProps}
                pageType={pageType && pageType.toLowerCase()}
                orderedIds={orderedIds}
              />
            )}
          </>
        </div>
      </div>
      <div className="add-entity-btns-section">
        {onAddButton || (
          <ButtonV2 type="button" onClick={handleAddClick} innerRef={triggerRef}>
            {onAddText || `Add A ${entityName}`}
          </ButtonV2>
        )}
        {showVirtualEventButton && (
          <AddAVirtualEventButton
            className="add-entity-btns-section__virtual"
            variant="secondary"
          />
        )}
      </div>
    </section>
  );
};

export default EditPageAddEntity;
